var _circle, _path, _path2, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#2D3F5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8948 48.4329C46.7428 48.4329 45.6548 48.2089 44.6308 47.7609C43.6068 47.3129 42.7161 46.6783 41.9588 45.8569C41.2121 45.0356 40.6734 44.0649 40.3428 42.9449L44.0708 41.9369C44.3374 42.8543 44.8228 43.5636 45.5268 44.0649C46.2414 44.5556 47.0254 44.7956 47.8788 44.7849C48.6361 44.7849 49.3134 44.6089 49.9108 44.2569C50.5081 43.9049 50.9774 43.4303 51.3188 42.8329C51.6601 42.2249 51.8308 41.5476 51.8308 40.8009C51.8308 39.6596 51.4628 38.7049 50.7268 37.9369C49.9908 37.1689 49.0414 36.7849 47.8788 36.7849C47.5268 36.7849 47.1801 36.8329 46.8388 36.9289C46.5081 37.0249 46.1881 37.1583 45.8788 37.3289L44.1188 34.2889L51.8628 27.6649L52.1988 28.5929H41.2388V24.9609H55.3668V28.6089L49.1428 34.5929L49.1108 33.4569C50.5081 33.5529 51.6974 33.9423 52.6788 34.6249C53.6708 35.3076 54.4281 36.1876 54.9508 37.2649C55.4841 38.3423 55.7508 39.5209 55.7508 40.8009C55.7508 42.2516 55.3934 43.5529 54.6788 44.7049C53.9748 45.8569 53.0254 46.7689 51.8308 47.4409C50.6468 48.1023 49.3348 48.4329 47.8948 48.4329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5282 48.4805C26.8962 48.4805 25.4562 48.1338 24.2082 47.4405C22.9602 46.7365 21.9842 45.7605 21.2802 44.5125C20.5869 43.2645 20.2402 41.8245 20.2402 40.1925V32.7685C20.2402 31.1365 20.5869 29.6965 21.2802 28.4485C21.9842 27.2005 22.9602 26.2298 24.2082 25.5365C25.4562 24.8325 26.8962 24.4805 28.5282 24.4805C30.1602 24.4805 31.5949 24.8325 32.8322 25.5365C34.0802 26.2298 35.0562 27.2005 35.7602 28.4485C36.4642 29.6965 36.8162 31.1365 36.8162 32.7685V40.1925C36.8162 41.8245 36.4642 43.2645 35.7602 44.5125C35.0562 45.7605 34.0802 46.7365 32.8322 47.4405C31.5949 48.1338 30.1602 48.4805 28.5282 48.4805ZM28.5282 44.8165C29.3389 44.8165 30.0749 44.6245 30.7362 44.2405C31.3976 43.8458 31.9202 43.3231 32.3042 42.6725C32.6882 42.0111 32.8802 41.2751 32.8802 40.4645V32.4805C32.8802 31.6591 32.6882 30.9231 32.3042 30.2725C31.9202 29.6111 31.3976 29.0885 30.7362 28.7045C30.0749 28.3098 29.3389 28.1125 28.5282 28.1125C27.7176 28.1125 26.9816 28.3098 26.3202 28.7045C25.6589 29.0885 25.1362 29.6111 24.7522 30.2725C24.3682 30.9231 24.1762 31.6591 24.1762 32.4805V40.4645C24.1762 41.2751 24.3682 42.0111 24.7522 42.6725C25.1362 43.3231 25.6589 43.8458 26.3202 44.2405C26.9816 44.6245 27.7176 44.8165 28.5282 44.8165Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3856_1793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#661CE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3856_1793)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 72,
    r: 21,
    fill: "white",
    fillOpacity: 0.24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step3.85a69f1742e7d8b3ed4368565fba6272.svg";
export { ForwardRef as ReactComponent };